import * as Yup from 'yup';

// FNP-1157: purchaseDate and expirationDate render as date pickers but were
// gated by nothing, so an expirationDate earlier than its purchaseDate was
// accepted. Both are validated here now.
//
// ⚠️ These are NOT a registration-term source. Deriving a term from the gap
// between them is silently wrong on every renewed domain: on renewal
// expirationDate moves and purchaseDate does not, so the gap grows to the
// cumulative registration length rather than the term. See
// docs/decisions/domain-registration-term-model.md §3.2. Nothing here should
// grow into a derived term field.
//
// ⚠️ .nullable() is load-bearing, not decoration. A record loaded for editing
// comes straight from the API (RecordForm assigns it onto initialValues
// verbatim), and GraphQL returns null — not undefined — for an absent optional
// field. Yup's .optional() alone rejects null, which would make every existing
// record with a blank date unsavable.
//
// Both dates stay OPTIONAL, matching the domain-bulk-import path, which
// validates format only when a value is present
// (FileProcessingService.validateSingleDomainData).
//
// The ordering rule is a deliberate divergence from bulk import, which has no
// such check. It belongs on both paths; adding it here fixes the surface this
// ticket is about without changing bulk-import behaviour under a bug ticket.
export const RecordSchema = Yup.object()
                               .shape({
                                          name: Yup.string()
                                                   .required('Required'),
                                          registrarId: Yup.string(),
                                          category: Yup.string(),
                                          purchaseDate: Yup.date()
                                                           .typeError('Please enter a valid date')
                                                           .nullable(),
                                          expirationDate: Yup.date()
                                                             .typeError('Please enter a valid date')
                                                             .nullable()
                                                             .min(
                                                                 Yup.ref('purchaseDate'),
                                                                 'Expiration date must be after the purchase date'
                                                             )
                                      });
